import { api } from '../utils/api'
import type { Table } from '../types/@types/table'

export interface TableApi {
  id: string
  numeroMesa: number
  capacidad: number
  estado: Table['status']
  createdAt?: string
}

export function mapTable(apiTable: TableApi): Table {
  const { id, numeroMesa, capacidad, estado, createdAt } = apiTable
  return {
    id: id,
    number: numeroMesa,
    capacity: capacidad,
    status: estado,
    createdAt,
  }
}

export async function getTables(): Promise<Table[]> {
  const { data } = await api.get<TableApi[]>('/tables')
  return data.map(mapTable)
}

export async function getTable(id: string | number): Promise<Table> {
  const { data } = await api.get<TableApi>(`/tables/${id}`)
  return mapTable(data)
}

export async function createTable(table: Omit<Table, 'id'>): Promise<Table> {
  const payload = {
    numeroMesa: table.number,
    capacidad: table.capacity,
    estado: table.status,
  }
  const { data } = await api.post<TableApi>('/tables', payload)
  return mapTable(data)
}

export async function updateTable(
  id: string,
  table: Omit<Table, 'id'>,
): Promise<Table> {
  const payload = {
    numeroMesa: table.number,
    capacidad: table.capacity,
    estado: table.status,
  }
  const { data } = await api.put<TableApi>(`/tables/${id}`, payload)
  return mapTable(data)
}

export async function deleteTable(id: string): Promise<void> {
  await api.delete(`/tables/${id}`);
}
export async function joinTables(primaryId: string, secondaryId: string) {
  if (!primaryId || !secondaryId) {
    throw new Error('Invalid ids')
  }
  return api.post('/tables/join', { primary_id: primaryId, secondary_id: secondaryId })
}

export async function unjoinTable(id: string) {
  if (!id) {
    throw new Error('Invalid id')
  }
  return api.post(`/tables/${id}/unjoin`)
}
